import React from "react";

import styles from "./Question.module.scss";

export type QuestionProps = {
  no: string;
  title: string;
  value: string;
  disabled: boolean;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

const Question: React.FC<QuestionProps> = ({
  no,
  title,
  value,
  disabled,
  onChange,
}) => {
  return (
    <div className={styles.question}>
      <p className={styles.title}>
        <span className={styles.no}>{no}</span>
        {title}
      </p>
      <textarea
        className={styles.textarea}
        value={value}
        placeholder={"テキストを入力してください。"}
        disabled={disabled}
        onChange={onChange}
      />
    </div>
  );
};

export default Question;
